import {
  SET_AVAILABILITY_RESPONSE,
  SET_IS_AT_LEAST_ONE_CHECKBOX_CHECKED,
  SET_IS_FETCHING_FOR_AVAILABILITY,
} from './mutations'
import WCSEyewearProtection from '@/scripts/libs/wcs/eyewear-protection'

export const ACTION_FETCH_AND_SET_AVAILABILITY_RESPONSE =
  'ACTION_FETCH_AND_SET_AVAILABILITY_RESPONSE'
export const ACTION_SET_IS_FETCHING_FOR_AVAILABILITY = 'ACTION_SET_IS_FETCHING_FOR_AVAILABILITY'
const ACTION_SET_AVAILABILITY_RESPONSE = 'ACTION_SET_AVAILABILITY_RESPONSE'
const ACTION_SET_IS_AT_LEAST_ONE_CHECKBOX_CHECKED = 'ACTION_SET_IS_AT_LEAST_ONE_CHECKBOX_CHECKED'

export const actions = {
  [ACTION_FETCH_AND_SET_AVAILABILITY_RESPONSE]: async function ({ dispatch }, payload) {
    const orderId = payload
    const response = await WCSEyewearProtection.fetchEyewearProtectionAvailability(orderId)

    const isAtLeastOneCheckboxChecked = response.some((item) => item?.eppSelected)

    if (isAtLeastOneCheckboxChecked) {
      dispatch(ACTION_SET_IS_AT_LEAST_ONE_CHECKBOX_CHECKED, true)
    }

    if (!isAtLeastOneCheckboxChecked) {
      dispatch(ACTION_SET_IS_AT_LEAST_ONE_CHECKBOX_CHECKED, false)
    }

    dispatch(ACTION_SET_AVAILABILITY_RESPONSE, response)
  },

  [ACTION_SET_AVAILABILITY_RESPONSE]: function ({ commit }, payload) {
    commit(SET_AVAILABILITY_RESPONSE, payload)
  },

  [ACTION_SET_IS_AT_LEAST_ONE_CHECKBOX_CHECKED]: function ({ commit }, payload) {
    commit(SET_IS_AT_LEAST_ONE_CHECKBOX_CHECKED, payload)
  },

  [ACTION_SET_IS_FETCHING_FOR_AVAILABILITY]: function ({ commit }, payload) {
    commit(SET_IS_FETCHING_FOR_AVAILABILITY, payload)
  },
}
